module.exports = __webpack_public_path__ + "img/em1.1e2b94a8.png";